import groq from 'groq'

import { callToAction } from '../../../projections/callToAction.js'
import { imageAsset } from '../../../projections/imageAsset'

export const header = groq`
  _type,
  upperTitle,
  title,
  description,

  ctas[]{...${callToAction()}},

  backgroundImage{...${imageAsset()}}
`
